import { Card } from "@/components/ui/card";
import { HeroConfig } from "@/config/heroConfig";

interface HeroFeatureCardsProps {
  features: HeroConfig['features'];
}

export const HeroFeatureCards = ({ features }: HeroFeatureCardsProps) => {
  return (
    <div className="flex-1 grid grid-cols-1 xs:grid-cols-2 gap-4 max-w-lg mx-auto lg:mx-0">
      {features.map((feature, index) => (
        <Card 
          key={index} 
          className="p-6 bg-white/95 backdrop-blur-sm shadow-card hover:shadow-playful transition-all duration-300 hover:scale-105"
        >
          <div className="text-center">
            <div className={`w-12 h-12 ${feature.gradient} rounded-full flex items-center justify-center mx-auto mb-3`}>
              <span className="text-2xl">{feature.icon}</span>
            </div>
            <div className="font-display font-semibold text-lg mb-2">{feature.title}</div>
            <p className="text-sm text-muted-foreground">{feature.description}</p>
          </div>
        </Card>
      ))}
    </div>
  );
};